import CrudRepository from './CrudRepository'
import Repository from './Repository'
import Store from '../store'
export default class SpecialOffersRepository extends CrudRepository {
  constructor () {
    super('core/api/specialOffers')
  }

  async getOffersByGsm (id, page, size) {
    const formData = new FormData()
    formData.append('gsm', Store.state.selectedNumber)
    const response = await Repository.post(`${this.resource}/forYou?page=${page}&size=${size}`, Store.state.selectedNumber !== null ? formData : '')
    return response
  }

  async getOfferDetails (id) {
    // const type = {
    //   headers: {
    //     'user-type': 'guest'
    //   }
    // }
    const formData = new FormData()
    formData.append('gsm', Store.state.selectedNumber)
    const data = await Repository.post(`${this.resource}/details/${id}`, formData)
    return data.data
  }
}
